export default __webpack_public_path__ + "static/media/050-lane.e8790c18.png";